import { QueryClient } from "react-query";

/**
 * React Query keys for the two views that surface employee clock state:
 * - "ShiftSiteAttendanceApiService": the site-level view (ShiftSiteAttendancePage)
 * - "LocationAttendanceApiService": the location-level detail view (ShiftSiteDetailPage)
 *
 * Any mutation that changes a clock record, override, no-show, replacement or
 * schedule override must invalidate BOTH so the open view refetches instead of
 * showing stale data. The global QueryClient uses `staleTime: 60s` and
 * `refetchOnWindowFocus: false` (see src/App.tsx), so simply navigating back to
 * a view does NOT refetch it — only an explicit invalidation (or a hard
 * refresh) does.
 *
 * Note: both hooks additionally poll every 30s on the live "today" view (see
 * each hook's `refetchInterval`) so out-of-band clock-ins (mobile/WhatsApp) and
 * roster changes — which originate outside this tab and never trigger the
 * invalidation above — still refresh the duty/post grouping.
 * Historical date ranges do not poll.
 */
export const ATTENDANCE_VIEW_QUERY_KEYS = [
  "ShiftSiteAttendanceApiService",
  "LocationAttendanceApiService",
] as const;

export const invalidateAttendanceViews = (queryClient: QueryClient): void => {
  ATTENDANCE_VIEW_QUERY_KEYS.forEach((key) => {
    queryClient.invalidateQueries([key]);
  });
};
